<template>
    <div>
        <div class="pt-2 pb-2">
            <div class="flow-root">
                <ul class="-mb-8">
                    <li class="flex flex-col items-center p-8" v-if="!loading && events.length === 0">No email events available</li>
                    <li v-for="(event, index) in events">
                        <div class="relative pb-8">
                            <span v-if="index !== events.length-1" class="absolute top-4 left-1 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true"></span>
                            <div class="relative flex space-x-3">
                                <div class="flex items-center justify-center">
                                    <!-- Creates a small circle -->
                                    <span class="h-2 w-2 rounded-full bg-gray-400 flex items-center justify-center ring-0">
                                    </span>
                                </div>
                                <div class="min-w-0 flex-1 pt-1.5 flex justify-between">

                                    <div class="flex flex-col">
                                        <div class="inline-grid grid-cols-4 gap-x-4">
                                            <div>
                                                <badge :class="eventClass(event.event)">{{ event.event | capitalize }}</badge>
                                            </div>
                                            <div class="col-span-2">{{ event.email_address }}</div>
                                            <div class="text-right text-sm whitespace-nowrap text-gray-500">
                                                {{ event.event_timestamp | datetimeWithSeconds }}
                                            </div>
                                        </div>
                                        <div class="inline-grid grid-cols-4 gap-x-4">
                                            <div class="col-span-4 text-xs mt-2 text-gray-800" v-if="event.reason">{{ event.reason }}</div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

    </div>
</template>

<script>
import Badge from "../library/Badge";

export default {
    name: "email-events",
    components: {Badge},
    props: ["email"],

    watch: {
        email (newValue) {
            if (newValue) {
                this.fetchEvents();
            }
        }
    },

    data () {
        return {
            events: [],
            loading: false
        };
    },

    methods: {

        fetchEvents () {
            this.loading = true;
            axios.get("/emails/" + this.email.id + "/events")
            .then(response => {
                this.events = response.data;
                this.loading = false;
            });
        },

        eventClass (event) {
            switch (event) {
                case "failed":
                    return "bg-red-400 text-white";
                case "delivered":
                    return "bg-green-400 text-white";
                default:
                    return "bg-indigo-400 text-white";
            }
        }

    }

};
</script>

<style scoped>

</style>